(function() {
  const exposed = {};

  function expose(name, fn) { exposed[name] = fn; }

  expose("tweet", function (button) {
    const url = encodeURIComponent(button.dataset.url);

    window.open(
      `https://x.com/intent/post?url=${url}`,
      "_blank",
      "noopener,noreferrer"
    );
  });

  expose("share", function (button) {
    const url = button.dataset.url;

    if (navigator.share) {
      navigator.share({ url });
      return;
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);

      const dialog = document.getElementById("message");
      if (dialog) {
        dialog.textContent = "Article URL copied to clipboard.";
        dialog.setAttribute("open", "");
        setTimeout(() => dialog.removeAttribute("open"), 3000);
      }
    }
  });

  document.addEventListener("click", e => {
    const trigger = e.target.closest("button[data-action]");
    if (!trigger) return;

    const fn = exposed[trigger.dataset.action];
    if (fn) fn(trigger);
  });

  function prefetch(e) {
    if (e.target.tagName != "A" || e.target.origin != location.origin) return;
    if (e.target.href.split("#")[0] === window.location.href.split("#")[0]) return;
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.href = e.target.href;
    document.head.appendChild(l);
  }
  document.documentElement.addEventListener("mouseover", prefetch, { capture: true, passive: true });
  document.documentElement.addEventListener("touchstart", prefetch, { capture: true, passive: true });

  if (window.ResizeObserver && document.querySelector("header nav #nav")) {
    const progress = document.getElementById("reading-progress");
    let timeOfLastScroll = 0;
    let requestedAniFrame = false;
    function updateProgress() {
      requestedAniFrame = false;
      const bottomSelector = document.querySelector("#comments,footer");
      if (!bottomSelector) return;

      const bottom = document.scrollingElement.scrollTop + bottomSelector.getBoundingClientRect().top;
      const winHeight = window.innerHeight;
      const percent = Math.min((document.scrollingElement.scrollTop / (bottom - winHeight)) * 100, 100);
      progress.style.transform = `translate(-${100 - percent}vw, 0)`;
      if (Date.now() - timeOfLastScroll < 3000) {
        requestAnimationFrame(updateProgress);
        requestedAniFrame = true;
      }
    }
    window.addEventListener("scroll", () => {
      if (!requestedAniFrame) {
        requestAnimationFrame(updateProgress);
        requestedAniFrame = true;
      }
      timeOfLastScroll = Date.now();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const css = document.getElementById('pagefind-css');
    if (css) {
      css.media = 'all';
    }
    if (document.querySelector('#search')) {
      new PagefindUI({ element: '#search', showSubResults: true, pageSize: 20 });
    }
  });
})();
